<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'全景导览'"></detailBread>
        <div class="container">
            <div class="page-title">
                全景导览
            </div>
            <div class="page-content">
                <!-- <img src="../images/zhtsg-dzjyxt-01.png" alt=""> -->
                <img src="../../../static/images/zhhq-qjdl-01.png" width="80%" />
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '全景导览', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '全景导览'
        },
        {
            name: 'description',
            content: '全景导览'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'6'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',6)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/qjdl.vue